import { Box, Column, Notification, Title } from 'rbx';
import React from 'react';
import { css } from 'emotion';
import SubscriptionDetails, { LIVE } from './SubscriptionDetails';
import CancelButtons from './CancelButtons';
import OrdersTable from './OrdersTable';
import InvoicesTable from './InvoicesTable';

/**
 * The user's .cv domain subscriptions — one per domain — with cancel actions,
 * and all their charges and invoices below.
 */
function DomainSubscriptions({ subscriptions, history, onCancel, onRefund }) {
  return (
    <Box
      className={css`
        margin-bottom: 1.5em;
      `}
    >
      <Title size={4}>.cv Domains</Title>
      {!subscriptions.length ? (
        <Notification>No domain subscriptions</Notification>
      ) : (
        <Column.Group multiline>
          {subscriptions.map(sub => (
            <Column size="half" key={sub.domainName}>
              <Title subtitle size={5}>
                {sub.domainName}
                {sub.domainId && (
                  <small
                    className={css`
                      margin-left: 0.5em;
                      color: #999;
                    `}
                  >
                    ola.cv id {sub.domainId}
                  </small>
                )}
              </Title>
              <SubscriptionDetails
                subscription={sub}
                extra={[['Registry auto-renew', sub.autoRenew ? 'On' : 'Off']]}
              />
              {LIVE.includes(sub.status) && (
                <CancelButtons
                  endingAlready={
                    sub.status === 'will_cancel_at_billing_period_end'
                  }
                  onCancel={immediately =>
                    onCancel(sub.domainName, immediately)
                  }
                />
              )}
            </Column>
          ))}
        </Column.Group>
      )}
      <OrdersTable orders={history.orders} onRefund={onRefund} showDomain />
      <InvoicesTable invoices={history.invoices} showDomain />
    </Box>
  );
}

export default DomainSubscriptions;
